
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"active-highlight",attrs:{"d":"M14.964 3.24l-.814-.224a.366.366 0 00-.308.033.427.427 0 00-.203.256L8.747 20.236a.393.393 0 00.033.321c.057.101.142.169.256.204l.813.223a.366.366 0 00.308-.033.427.427 0 00.203-.256l4.892-16.931a.394.394 0 00-.033-.322.426.426 0 00-.255-.203z","fill":"#E2E4EC"}}),_c('path',{attrs:{"d":"M7.633 6.544a.415.415 0 00-.131-.301l-.656-.656a.415.415 0 00-.302-.131.415.415 0 00-.301.13L.13 11.699a.414.414 0 000 .604l6.112 6.111a.414.414 0 00.603 0l.656-.655a.415.415 0 000-.604L2.348 12l5.154-5.154a.414.414 0 00.131-.302zM23.869 11.698l-6.112-6.111a.415.415 0 00-.301-.132.416.416 0 00-.302.132l-.656.655a.414.414 0 000 .604L21.652 12l-5.154 5.154a.414.414 0 000 .604l.656.655a.414.414 0 00.603 0l6.112-6.111a.415.415 0 000-.604z","fill":"#00003C"}})])
          )
        }
      }
    